export const hardRefreshPage = () => {
  const run = () => {
    window.stop();
    window.location.reload();
  };

  run();
};
